export default __webpack_public_path__ + "static/media/property_1017.e88e271f.png";